module.exports = "/packs/step1-sp-d536fa41db34aa32fc659015578af49a.png";